import { FC } from 'react'

import { TariffType } from '@/api/models/parking/lib/parking.types'
import { cn } from '@/app/utils'

type Tab = { key: TariffType; title: string }

type Props = {
  tabs: Tab[]
  selectedTab: TariffType
  onTabChange: (tab: TariffType) => void
}

export const TariffTabs: FC<Props> = ({ tabs, selectedTab, onTabChange }) => (
  <>
    <div className="flex">
      {tabs.map(option => (
        <button
          key={option.key}
          type="button"
          className={cn(
            'w-full gap-x-4 border-b-[3px] pb-8 font-bold transition-colors !text-20',
            selectedTab === option.key
              ? 'border-bronze-40'
              : 'border-transparent text-grey-60'
          )}
          onClick={() => option.key !== selectedTab && onTabChange(option.key)}
        >
          <span>{option.title}</span>
        </button>
      ))}
    </div>
    <hr className="mb-32 h-1 w-full text-grey-30" />
  </>
)
